import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { Box, Button } from '@mui/material';

import { RefObject, useRef } from 'react';

export const AudioSelector = ({ src, onSelect }: { src?: string; onSelect: (e: React.MouseEvent<HTMLElement>, ref: RefObject<HTMLElement | null>) => void }) => {
    const selectorRef = useRef<HTMLDivElement>(null);

    return (
        <Box
            sx={{
                width: '100%',
                aspectRatio: 1,
                borderRadius: '50%',
            }}
            ref={selectorRef}
        >
            {!src ? (
                <Button
                    sx={{
                        flex: 1,
                        width: '100%',
                        height: '100%',
                    }}
                    onClick={(e) => onSelect(e, selectorRef)}
                >
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <VolumeUpIcon sx={{ height: '100%', width: '100%', color: (theme) => (theme.vars || theme).palette.grey[400] }} />
                    </Box>
                </Button>
            ) : (
                <Button
                    sx={{
                        //
                        flex: 1,
                        width: '100%',
                        height: '100%',

                        border: 5,
                        borderColor: (theme) => (theme.vars || theme).palette.grey[600],
                        borderRadius: '14%',
                        color: 'black',
                        bgcolor: 'white',
                    }}
                    onClick={(e) => onSelect(e, selectorRef)}
                >
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <VolumeUpIcon sx={{ height: '100%', width: '100%', color: (theme) => (theme.vars || theme).palette.grey[600] }} />
                    </Box>
                </Button>
            )}
        </Box>
    );
};
